import { useParams, Navigate } from 'react-router-dom';
import MaestroSimulations from '@/components/simulation/MaestroSimulations.tsx';
import { maestros } from '@/types/maestro.ts';

export default function MaestroPage() {
  const { id } = useParams<{ id: string }>();
  const maestro = maestros.find((m) => m.id === id);

  if (!maestro) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="animate-fade-in">
      <MaestroSimulations maestro={maestro} />
    </div>
  );
}
